/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Cognos Analytics Home
 *| (C) Copyright IBM Corp. 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

define([
	'i18n!./CognosAnalyticsHomeResources',
	'polyglot'
], function (resources, Polyglot) {

	class StringResources {

		constructor() {
			/**
			 * Module which provides simple access to string resources.
			 */
			this.polyglot = new Polyglot({
				phrases: resources
			});
		}

		/**
		 * Get the string resource for the given key and interpolation options
		 *
		 * @param key						The key of the string to return
		 * @param interpolationOptions		Optional interpolation options (see poly.t documentation for details)
		 * @returns							The string to display
		 */
		get(key, interpolationOptions = {}) {
			return this.polyglot.t(key, interpolationOptions);
		}

	}

	return new StringResources();

});